module.exports = __webpack_public_path__ + "media/physics.f2d8942d.mp4";